import { Flex, Button, Text, Input } from "@chakra-ui/react";
import { CgAdd, CgSearch } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { showModalCreate } from "../actions/productActions";

const TableTools = ({ searchTerm, setSearchTerm, listProducts, loading}) => {
  const dispatch = useDispatch();

  const onSearch = () => {
    dispatch(listProducts({
        name: searchTerm,
        description: searchTerm,
    }));
  };

  return (
    <Flex w="100%" pb="20px" justifyContent="space-between">
      <Button
        onClick={() => dispatch(showModalCreate())}
      >
        <CgAdd />
        <Text ml=".3em">Crear Producto </Text>
      </Button>
      <Flex pl="20px">
        <Input
            disabled={loading}
          w="350px"
          placeholder="Nombre, descripción, o categoría"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button 
            disabled={loading}
            onClick={onSearch}
        >
          <CgSearch />
        </Button>
      </Flex>
    </Flex>
  );
};

export default TableTools;
